import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { Base64 } from "js-base64";
import { useEffect } from "react";
import { GetUTCTime } from "../../Helpers/GetUTCTime";
import { UpdateTemplateDataSpecificWithLoader } from "../../Helpers/ApiCall";
import { updateISNTemplates } from "../../Helpers/ApiCall";
import { useDispatch } from "react-redux";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import DeleteConfirmationDialog from "../../Common/Alert/DeleteConfirmationDialog";
import { TEMPLATE_PICKER_PAPER_PROPS, TemplateSearchEmptyState, TemplateSearchField } from "../../Common/TemplateSearch/TemplateSearchField";
import { filterTemplatesByName } from "../../Helpers/TemplateSearchUtils";
import { useNavigate } from "react-router-dom";

function AddTemplateModal({ setAddTemplateModal, addTemplateModal, setDeteleteTemplateModal, deleteTemplateModal, templateList, storeData }) {
  const [selectedTemplatesGuid, setSelectedTemplatesGuid] = useState([]);
  const [restoreTemplatesGuid, setRestoreTemplatesGuid] = useState([]);
  const [cureentClickTemplates, setCurrentClickTemplate] = useState([]);
  const [showTextBoxModal, setShowTextBoxModal] = useState(false);
  const [deleteTextBoxModal, setDeleteTextBoxModal] = useState(false);
  const [deleteTemplatesList, setdeleteTemplatesList] = useState([]);
  const [deleteselectedTemplatesGuid, setDeleteSelectedTemplatesGuid] = useState([]);
  const [validate, setValidate] = useState("");
  const [addTemplateFlag, setAddTemplateFlag] = useState(false);
  const [inputChanged, setInputChanged] = useState(false);
  const [removeInputChanged, setremoveInputChanged] = useState(false);
  const [templateSearchQuery, setTemplateSearchQuery] = useState("");
  const defaulttemplatearr = storeData?.inspectionData?.data?.inspectiontemplates?.map((temp) => {
    return temp?.template_guid;
  });

  const searchFilteredTemplateList = filterTemplatesByName(templateList, templateSearchQuery);

  const defaultDeletearr = storeData?.inspectionData?.data?.inspectiontemplates;
  const softdeletedGuidArr = deleteTemplatesList?.map((value) => {
    return value?.template_uuid;
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // priviously  text model
  const handleTextModelClose = () => {
    setShowTextBoxModal(false);
  };

  // priviously deleted text model
  const handleDeleteTextModelClose = () => {
    setDeleteTextBoxModal(false);
  };

  // template add functions
  const handleAddClose = () => {
    setInputChanged(false);
    setAddTemplateModal(false);
    setSelectedTemplatesGuid([]);
    setRestoreTemplatesGuid([]);
    setValidate("");
    setTemplateSearchQuery("");
  };

  let updatedTemplates = selectedTemplatesGuid.map(template => {
    if (defaulttemplatearr?.includes(template) || softdeletedGuidArr?.includes(template)) {
      return {
        template_guid: uuidv4(),  // New GUID
        master_template_guid: template,
      };
    } else {
      return {
        template_guid: template,
        master_template_guid: template  // Copy template_guid to master
      };
    }
  });


  // for add api
  const handleAddTemplate = async (selectedNewGuids = selectedTemplatesGuid, selectedRestoreGuids = restoreTemplatesGuid) => {
    let errorEl = document.getElementById("template_selection_error_text");
    
    // Normalize in case selectedNewGuids is passed from legacy callers/tests
    let newGuids = Array.isArray(selectedNewGuids) ? selectedNewGuids : selectedTemplatesGuid;
    let restoreGuids = Array.isArray(selectedRestoreGuids) ? selectedRestoreGuids : restoreTemplatesGuid;

    let updatedTemplates = [];

    // Flow 1 — Assign from "New templates" (create fresh blank instance with new GUID if active or previously deleted)
    newGuids.forEach(templateGuid => {
      if (defaulttemplatearr?.includes(templateGuid) || softdeletedGuidArr?.includes(templateGuid)) {
        updatedTemplates.push({
          template_guid: uuidv4(), // New GUID for fresh instance
          master_template_guid: templateGuid,
        });
      } else {
        updatedTemplates.push({
          template_guid: templateGuid,
          master_template_guid: templateGuid,
        });
      }
    });

    // Flow 2 — Restore from "Previously deleted" (restore original instance with original GUID and data)
    restoreGuids.forEach(templateGuid => {
      updatedTemplates.push({
        template_guid: templateGuid, // Original GUID to restore existing instance
        master_template_guid: templateGuid,
      });
    });

    if (updatedTemplates.length === 0) {
      return;
    }

    if (errorEl) errorEl.innerText = "";
    const formData = {
      guid: sessionStorage.getItem("guid"),
      order_id: Base64.decode(sessionStorage.getItem("AC")) == "ISN" ? sessionStorage.getItem("guid") : sessionStorage.getItem("orderId"),
      inspection_from: Base64.decode(sessionStorage.getItem("AC")),
      templates: updatedTemplates,
    };
    updateISNTemplates(dispatch, formData);
    setAddTemplateFlag(true);
    setAddTemplateModal(false);
    setSelectedTemplatesGuid([]);
    setRestoreTemplatesGuid([]);
    setValidate("");
    setTemplateSearchQuery("");
    setShowTextBoxModal(false);
  };

  const handleTemplateSelection = (template, isRestore = false) => {
    setInputChanged(true);
    setValidate("");
    if (isRestore) {
      const currentIndex = restoreTemplatesGuid.indexOf(template.guid);
      const newChecked = [...restoreTemplatesGuid];
      if (currentIndex === -1) {
        newChecked.push(template.guid);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setRestoreTemplatesGuid(newChecked);
    } else {
      const currentIndex = selectedTemplatesGuid.indexOf(template.guid);
      const newChecked = [...selectedTemplatesGuid];
      if (currentIndex === -1) {
        newChecked.push(template.guid);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setSelectedTemplatesGuid(newChecked);
    }
  };

  // for delete function
  const handleDeleteClose = () => {
    setremoveInputChanged(false);
    setDeteleteTemplateModal(false);
    setDeleteSelectedTemplatesGuid([]);
  };


  const handleDeleteTemplate = async (deleteselectedTemplatesGuid) => {
    let errorEl = document.getElementById("template_selection_error_text2");

    // Validation: must have at least one remaining template
    if (defaultDeletearr?.length === 1 || defaultDeletearr?.length === deleteselectedTemplatesGuid?.length) {
      errorEl.innerText = "You must have at least one template within your inspection.";
      setDeleteTextBoxModal(false);
      return;
    }

    errorEl.innerText = "";

    // Clone the current store data
    let prevData = JSON.parse(JSON.stringify(storeData?.inspectionData?.data));
    delete prevData?.report_media_library_files;

    // Find and update only the templates to delete
    let updatedTemplates = [];
    for (let template of storeData?.inspectionData?.data?.inspectiontemplates) {
      if (deleteselectedTemplatesGuid.includes(template.template_guid)) {
        updatedTemplates.push({
          ...template,
          is_deleted: 1,
          updated_at: await GetUTCTime(),
        });
      }
    }

    // Prepare new data with only updated templates
    let inspectionData = JSON.parse(JSON.stringify(prevData));
    let filteredData = {
      ...JSON.parse(JSON.stringify(prevData)),
      inspectiontemplates: updatedTemplates,
    };
    let payload = {
      guid: inspectionData?.guid,
      inspectiontemplates: updatedTemplates?.map((updatedTemplate) => {
        const {
          categories,
          location_data,
          rating_data,
          ...rest
        } = updatedTemplate;
        return rest;
      })
    }

    // Send to backend
    if (updatedTemplates.length > 0) {
      await UpdateTemplateDataSpecificWithLoader(dispatch, prevData, payload);
    }

    // Filter templates that are NOT being deleted to find one for navigation
    const filterTemplate = defaultDeletearr.filter(
      val => !deleteselectedTemplatesGuid.includes(val?.template_guid)
    );

    // Navigate to remaining template
    if (filterTemplate.length > 0) {
      navigate("/inspection", {
        state: {
          template: filterTemplate[0],
          template_id: filterTemplate[0].template_id,
          tempIndex: "0",
        },
      });
    }

    // Reset UI and selections
    setDeteleteTemplateModal(false);
    setDeleteSelectedTemplatesGuid([]);
    setDeleteTextBoxModal(false);
  };




  const validation = (template) => {
    setInputChanged(true);
    setValidate("");
    handleTemplateSelection(template, true);
    setShowTextBoxModal(false);
  };

  const handleDeleteTemplateSelection = (template) => {
    setremoveInputChanged(true);
    const currentIndex = deleteselectedTemplatesGuid.indexOf(template.template_guid);
    const newChecked = [...deleteselectedTemplatesGuid];
    if (currentIndex === -1) {
      newChecked.push(template?.template_guid);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setDeleteSelectedTemplatesGuid(newChecked);
  };

  useEffect(() => {
    setdeleteTemplatesList(storeData?.deletedTemplateData?.data);
  }, [storeData?.deletedTemplateData]);

  useEffect(() => {
    if (storeData?.inspectionData) {
      if (addTemplateFlag) {
        navigate("/inspection", {
          state: {
            template: storeData?.inspectionData?.data?.inspectiontemplates[0],
            template_id: storeData?.inspectionData?.data?.inspectiontemplates[0].template_id,
            tempIndex: "0",
          },
        });
        setAddTemplateFlag(false);
      }
    }
  }, [storeData?.inspectionData]);

  return (
    <>
      {/* add template modal */}
      {addTemplateModal && (
        <Dialog
          className="dialog-container-new-category"
          open={addTemplateModal}
          onClose={handleAddClose}
          aria-labelledby="category-modal"
          onBackdropClick="false"
          aria-describedby="category-modal-description"
          PaperProps={TEMPLATE_PICKER_PAPER_PROPS}
        >
          <div className="close-wrapper-new-line">
            <div className="close-wrapper-attachment">
              <CloseIcon onClick={handleAddClose} />
            </div>
          </div>
          <DialogTitle className="new-category-dialog-title mb-6">{"Add templates"}</DialogTitle>
          <span className="category-dialog-subtitle p-custom">Choose templates below to add. </span>
          <DialogContent className="dialog-content-new-category template-picker-content">
            <TemplateSearchField searchQuery={templateSearchQuery} onSearchQueryChange={setTemplateSearchQuery} />
            <Grid container className="input-controll template-picker-list">
              <Grid item xs={12}>
                {searchFilteredTemplateList?.length === 0 && <TemplateSearchEmptyState />}
                {searchFilteredTemplateList?.filter(e => softdeletedGuidArr?.includes(e?.guid))?.length > 0 && <p className="prev_deleted_lable">Previously deleted</p>}
                {searchFilteredTemplateList?.filter(e => softdeletedGuidArr?.includes(e?.guid))?.map((template) => (
                  <Grid
                    container
                    display={"flex"}
                    gap={2}
                    key={`restore-${template?.guid}`}
                    onClick={() =>
                      restoreTemplatesGuid?.includes(template?.guid)
                        ? handleTemplateSelection(template, true)
                        : (setShowTextBoxModal(true), setCurrentClickTemplate(template))
                    }
                    className={`bordered__text ${restoreTemplatesGuid?.includes(template?.guid) ? "cat_selected2" : ""}`}
                  >
                    <Grid item xs={0.5} display={"flex"} alignItems={"center"}>
                      {template?.is_pdf_template === 1 ? <PictureAsPdfOutlinedIcon /> : null}
                    </Grid>
                    <Grid item xs={9}>
                      <span className="bordered__text__content">
                        {template?.name}
                      </span>
                    </Grid>
                    <Grid item xs={1}>
                      <DoneIcon className="cat_seleted_icon" />
                    </Grid>
                  </Grid>
                ))}

                {searchFilteredTemplateList?.length > 0 && (
                  <p className="prev_deleted_lable">{softdeletedGuidArr?.length > 0 ? "Blank" : "New templates"}</p>
                )}
                {searchFilteredTemplateList?.map((template) => (
                  <Grid
                    container
                    display={"flex"}
                    gap={2}
                    key={`new-${template?.guid}`}
                    onClick={() => handleTemplateSelection(template, false)}
                    className={`bordered__text ${selectedTemplatesGuid?.includes(template?.guid) ? "cat_selected2" : ""}`}
                  >
                    <Grid item xs={0.5} display={"flex"} alignItems={"center"}>
                      {template?.is_pdf_template === 1 ? <PictureAsPdfOutlinedIcon /> : null}
                    </Grid>
                    <Grid item xs={9}>
                      <span className="bordered__text__content">
                        {template?.name}
                      </span>
                    </Grid>
                    <Grid item xs={1}>
                      <DoneIcon className="cat_seleted_icon" />
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className="template-selection-modal-action">
            <div id="template_selection_error_text">{validate}</div>
            <Button
              disabled={!inputChanged || (selectedTemplatesGuid?.length === 0 && restoreTemplatesGuid?.length === 0)}
              className="add-category-btn"
              onClick={() => {
                handleAddTemplate();
              }}
            >
              Add to report
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* delete template modal */}
      {deleteTemplateModal && (
        <Dialog
          className="dialog-container-new-category"
          open={deleteTemplateModal}
          onClose={handleDeleteClose}
          aria-labelledby="category-modal"
          onBackdropClick="false"
          aria-describedby="category-modal-description"
        >
          <div className="close-wrapper-new-line">
            <div className="close-wrapper-attachment">
              <CloseIcon onClick={handleDeleteClose} />
            </div>
          </div>
          <DialogTitle className="new-category-dialog-title mb-6">{"Remove templates"}</DialogTitle>
          <span className="category-dialog-subtitle p-custom">You must have at least one template in your inspection. </span>
          <DialogContent className="dialog-content-new-category">
            <Grid container className="input-controll">
              <Grid item xs={12}>
                {defaultDeletearr?.map((template, index) => (
                  <Typography
                    key={index}
                    onClick={() => handleDeleteTemplateSelection(template)}
                    className={`bordered__text ${deleteselectedTemplatesGuid.includes(template.template_guid) && "cat_selected2"}`}
                  >
                    <span className="bordered__text__content">
                      <span className="delete_modal_pdf_icon"> {template?.is_pdf_template === 1 ? <PictureAsPdfOutlinedIcon /> : null}</span>
                      <span
                        className="bordered__text__content"
                        style={{
                          marginLeft: template?.is_pdf_template !== 1 ? "22px" : undefined,
                        }}
                      >
                        {" "}
                        {template?.name}{" "}
                      </span>
                    </span>
                    <DoneIcon className="cat_seleted_icon" />
                  </Typography>
                ))}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className="template-selection-modal-action">
            <div id="template_selection_error_text2"></div>
            <Button
              className="add-category-btn"
              disabled={!removeInputChanged || deleteselectedTemplatesGuid?.length === 0}
              onClick={() => (deleteselectedTemplatesGuid?.length === 0 ? setDeteleteTemplateModal(false) : setDeleteTextBoxModal(true))}
            >
              remove selected
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* text Box modal  */}
      {showTextBoxModal && (
        <Dialog className="dialog-container-add-template" open={showTextBoxModal} onClose={handleTextModelClose} aria-labelledby="category-modal" aria-describedby="category-modal-description">
          <div className="close-wrapper-new-line">
            <div className="close-wrapper-attachment">
              <CloseIcon onClick={handleTextModelClose} />
            </div>
          </div>
          <DialogContent className="dialog-container-add-template" sx={{ paddingBottom: "0px !important" }}>
            <DialogTitle
              sx={{
                fontSize: "16px !important",
                paddingLeft: "0px !important",
                fontWeight: 700,
              }}
            >
              {"Add template"}
            </DialogTitle>

            <Grid container className="input-controll" sx={{ paddingBottom: "0px !important" }}>
              <Grid item xs={12}>
                <span>This action will add back your previously deleted template.</span>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className="new-category-modal-action">
            <Button
              sx={{
                fontWeight: "700 !important",
                ":hover": { backgroundColor: "transparent" },
              }}
              onClick={() => setShowTextBoxModal(false)}
            >
              GO BACK
            </Button>
            <Button
              sx={{
                fontWeight: "700 !important",
                paddingLeft: "0px",
                ":hover": { backgroundColor: "transparent" },
              }}
              onClick={() => {
                validation(cureentClickTemplates);
              }}
            >
              ADD TEMPLATE
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* text box modal for remove */}
      <DeleteConfirmationDialog
        open={deleteTextBoxModal}
        handleClose={handleDeleteTextModelClose}
        title={"Remove templates"}
        contentText={"Are you sure you want to delete this template and all associated data?"}
        cancelBtnTitle={"CANCEL"}
        cancelBtnAction={handleDeleteTextModelClose}
        submitBtnTitle={"YES, DELETE"}
        submitBtnAction={handleDeleteTemplate}
        submitBtnParam={deleteselectedTemplatesGuid}
      />
    </>
  );
}

export default AddTemplateModal;
